import { render } from "./AbsoluteMenu.vue?vue&type=template&id=9032a2a0"
import script from "./AbsoluteMenu.vue?vue&type=script&lang=ts"
export * from "./AbsoluteMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script